/**
 * LoadOrgChart module - requires window.go (chart.js), window.Robot (Robot.js)
 * Refactored: diagram logic split into modules (diagram-*.js, diagram-blocks, diagram-node-mutation).
 */
import { SideTreeLayout, isAssistant, changeLabel } from './modules/diagram-layout.js';
import { searchDiagram, centerToNextResult, centerToPreviousResult, clearSearch } from './modules/diagram-search.js';
import { cxcommand, changeColor, clickContextMenu, clickNodewithKey, getNodeDatawithKey, rightClickNodeWithKey, doubleClickNodewithKey } from './modules/diagram-context-menu.js';
import { showNoCreditsModal, showPersonNotFoundModal } from './modules/diagram-modals.js';
import { save, load, createImage, makeBlob, myCallback, createExcelFromData, downloadNodeDatatoExcel, downloadExcel, downloadPeopleResults, saveToList } from './modules/diagram-export.js';
import { clearSelectedBlocksList, addToSelectedBlocksList, addToDeletedBlocksList, addNewNode, addBlockModal, createNewBlock, manuallyAddPersonToBlock, confirmAddPersonToBlock, editBlockModal, deletePerson } from './modules/diagram-blocks.js';
import { processMultipleNodes, processCandidate, compute_credits, editNodesFromPreviousActivity, updateMultipleNodesOrgChartDataFunctGrade, changeNodeDataUsingQueryResponse } from './modules/diagram-node-mutation.js';

const go = typeof window !== 'undefined' ? window.go : null;

function loadOrgChartDiagram(chart_div_name) {

    // clearSelectedBlocksList()
    console.log("init FUNCTION CALLED with chart-div-name", chart_div_name);

    sessionStorage['just_loaded']='yes'
    if (window.goSamples) goSamples(); // init for these samples -- you don't need to call this
    var $ = go.GraphObject.make; // for conciseness in defining templates
    console.log("This is the chart_div_name::",chart_div_name)

    // if (typeof(chart_div_name)=='string'){
    //     window.myDiagram = creatMyDiagram()
    // }
    window.myDiagram =
        $(go.Diagram,chart_div_name, // must be the ID or reference to div
            {
                "dragSelectingTool.isEnabled": false,
                initialContentAlignment: go.Spot.Center,
                autoScrollInterval:10,
                scrollVerticalLineChange:200,
                scrollHorizontalLineChange:200,

                defaultCursor:"all-scroll",
                // initialAutoScale: go.Diagram.Uniform,
                //maxSelectionCount: 1, // users can select only one part at a time
                validCycle: go.Diagram.CycleDestinationTree, // make sure users can only create trees
            //    "clickCreatingTool.archetypeNodeData": { // allow double-click in background to create a new node
            //        name: "(new person)",
            //        title: "",
            //        comments: ""
            //    },
                "clickCreatingTool.insertPart": function(loc) { // scroll to the new node
                    var node = go.ClickCreatingTool.prototype.insertPart.call(this, loc);
                    if (node !== null) {
                        this.diagram.select(node);
                        this.diagram.commandHandler.scrollToPart(node);
                        this.diagram.commandHandler.editTextBlock(node.findObject("NAMETB"));
                    }
                    return node;
                },
                layout: 
                $(SideTreeLayout,
                    {
                      treeStyle: go.TreeLayout.StyleLastParents,
                      arrangement: go.TreeLayout.ArrangementHorizontal,
                      // properties for most of the tree:
                      angle: 90,
                      layerSpacing: 35,
                      // properties for the "last parents":
                      alternateAngle: 90,
                      alternateLayerSpacing: 35,
                      alternateAlignment: go.TreeLayout.AlignmentBus,
                      alternateNodeSpacing: 20
                    }),
                "undoManager.isEnabled": true, // enable undo & redo
            });

    // Lets centerRect() scroll the CEO/root into the viewport (node at top of document).
    window.myDiagram.scrollMargin = new go.Margin(800);

    // This is the actual HTML context menu:
    var cxElement = document.getElementById("contextMenu");
    // an HTMLInfo object is needed to invoke the code to set up the HTML cxElement
    var myContextMenu = $(go.HTMLInfo, {
        show: showContextMenu,
        hide: hideContextMenu
      });
  

    // Overview
    window.myOverview =
    $(go.Overview, "myOverviewDiv",  // the HTML DIV element for the Overview
        { observed: window.myDiagram, contentAlignment: go.Spot.Center });   // tell it which Diagram to show and pan


    // when the user deletes something
    window.myDiagram.addDiagramListener("LayoutCompleted", function(e) {
        if (sessionStorage['just_loaded']=='yes'){
            sessionStorage['just_loaded']='no'

        } else {
            console.log('modified!')
        }
    });
    // window.myDiagram.commandHandler = new DrawCommandHandler();
    // window.myDiagram.scroll.dist = 2;

    // window.myDiagram.commandHandler.arrowKeyBehavior = "scroll";

    window.myRobot = new Robot(window.myDiagram);  // defined in Robot.js

    // notice whenever a transaction or undo/redo has occurred
    window.myDiagram.addModelChangedListener(function(evt) {
    if (evt.isTransactionFinished) {
        if (evt.propertyName == 'FinishedUndo') {
            console.log('saving undo')
        }
        if (evt.propertyName == 'FinishedRedo') {
            console.log('saving redo')
        }
    }
    });

    // manage boss info manually when a node or link is deleted from the diagram
    window.myDiagram.addDiagramListener("ChangedSelection", function(e) {

        // showPaymentPopUpWhenLoggedOut()

        // for each of the blocks potentially selected, first compile the selected blocks list
        clearSelectedBlocksList()
        e.subject.each(function(p) {
            var part = p.part
            addToSelectedBlocksList(part.key)
        })
    })

    // manage boss info manually when a node or link is deleted from the diagram
    window.myDiagram.addDiagramListener("SelectionDeleting", function(e) {

        // for each of the blocks potentially selected, first compile the deleted_blocks list
        e.subject.each(function(p) {
            // when a block is deleted manually by a user, add it to a list of deleted blocks so this change can be propagated
            console.log(p.part.data);
            var part = p.part
            addToDeletedBlocksList(part.key)
        })

        // ...and then again, for each of the blocks potentially selected kill the block
        e.subject.each(function(p) {
            var part = p.part

            window.myDiagram.startTransaction("clear boss");
            if (part instanceof go.Node) {

                var it = part.findTreeChildrenNodes(); // find all child nodes
                while (it.next()) { // now iterate through them and clear out the boss information
                    var child = it.value;
                    var bossText = child.findObject("boss"); // since the boss TextBlock is named, we can access it by name
                    if (bossText === null) return;
                    bossText.text = "";
                }
            } else if (part instanceof go.Link) {
                var child = part.toNode;
                var bossText = child.findObject("boss"); // since the boss TextBlock is named, we can access it by name
                if (bossText === null) return;
                bossText.text = "";
            }
            window.myDiagram.commitTransaction("clear boss");
        })
    });

    // var levelColors = ["#AC193D", "#2672EC", "#8C0095", "#5133AB",
    //     "#008299", "#D24726", "#008A00", "#094AB2"
    // ];

	var levelColors = ["#AC193D", "#2672EC", "#8C0095", "#5133AB", "#008299", "#D24726", "#008A00", "#094AB2"];

    // override TreeLayout.commitNodes to also modify the background brush based on the tree depth level
    try{
        console.log("Going to modify backgroud brush")
        window.myDiagram.layout.commitNodes = function () {
            go.TreeLayout.prototype.commitNodes.call(window.myDiagram.layout); // do the standard behavior
            // then go through all of the vertexes and set their corresponding node's Shape.fill
            // to a brush dependent on the TreeVertex.level value
            try{
                window.myDiagram.layout.network.vertexes.each(function (v) {
                    if (v.node) {
    
                        try{
                            var level = v.level % (levelColors.length);
                            var color = levelColors[level];
                            var shape = v.node.findObject("SHAPE");
                            var shape2 = v.node.findObject("SHAPE2");
                            if (shape){
                                shape.stroke = $(go.Brush, "Linear", { 0: color, 1: go.Brush.lightenBy(color, 0.05), start: go.Spot.Left, end: go.Spot.Right });
                            } 
                            if (shape2) shape2.stroke = $(go.Brush, "Linear", { 0: color, 1: go.Brush.lightenBy(color, 0.05), start: go.Spot.Left, end: go.Spot.Right });
                            }
                        catch(error){
                            console.log("Error:: in tree vertex layout network", error)
            
                        }
                        // console.log("Come here to modify level color")
    
                    }
                });
            }
            catch{}
            
        };
    
    }
    catch{
        // debugger;
        console.log("There's an error here in commiting nodes!!")
    }
    


    // Disabled for the availab
    // window.myDiagram.toolManager.standardMouseWheel = function() {
    //   var observed  = window.myOverview.observed;
    //   if (observed === null) return;
    //   var cmd = observed.commandHandler;

    //   var e = window.myDiagram.lastInput;
    //   var delta = e.delta;
    //   if (delta === 0) return;

    //   if ((delta > 0 ? cmd.canIncreaseZoom() : cmd.canDecreaseZoom())) {
    //     if (delta > 0)
    //       cmd.increaseZoom();
    //     else
    //       cmd.decreaseZoom();
    //     e.bubbles = false;
    //   }

    // } // end custom standardMouseWheel

    
    

    // window.myDiagram.contextMenu =
    //     $("ContextMenu",
    //     $("ContextMenuButton",
    //     {
    //         "ButtonBorder.fill": "white",
    //         "_buttonFillOver": "skyblue",
    //         "_buttonID" : 'fetchCanvasEntireCompanyDataResults'
    //         },
    //     $(go.TextBlock, "Fetch all people in this company"), {
            
    //         click: function(e, obj) {
    //             // reparent the subtree to this node's boss, then remove the node
    //             var node = obj.part.adornedPart;
    //             // 
    //             // fetchEntireCompanyDataResults(e,obj)
    //             fetchNodeContextMenuClickedResults(e,obj)
    //         }
    //     },
    //     new go.Binding("visible", "", function(e, obj) {return showIfSelectionIsNotMultiple(e)})
    //     ),
    //     $("ContextMenuButton",
    //     {
    //         "ButtonBorder.fill": "white",
    //         "_buttonFillOver": "skyblue",
    //         "_buttonID" : 'viewCanvasNodeDataInCompaniesTab'
    //         },
    //     $(go.TextBlock, "View in Company Tab"), {
            
    //         click: function(e, obj) {
    //             // reparent the subtree to this node's boss, then remove the node
    //             var node = obj.part.adornedPart;
    //             // 
    //             // viewNodeDataInCompaniesTab(e,obj)
    //             fetchNodeContextMenuClickedResults(e,obj)
    //         }
    //     },
    //     new go.Binding("visible", "", function(e, obj) {return showIfSelectionIsNotMultiple(e)})
    //     ),

    //     $("ContextMenuButton",
    //     {
    //         "ButtonBorder.fill": "white",
    //         "_buttonFillOver": "skyblue",
    //         "_buttonID" : 'viewCanvasNodeDataInPeopleTab'

    //         },
    //     $(go.TextBlock, "View in People Tab"), {
            
    //         click: function(e, obj) {
    //             // reparent the subtree to this node's boss, then remove the node
    //             var node = obj.part.adornedPart;
    //             // 
    //             // viewNodeDataInPeopleTab(e,obj)
    //             fetchNodeContextMenuClickedResults(e,obj)
    //         }
    //     },
    //     new go.Binding("visible", "", function(e, obj) {return showIfSelectionIsNotMultiple(e)})
    //     ),

        
    //     );




    window.myDiagram.contextMenu = myContextMenu;
    console.log("this is the cx element::", cxElement)
    // We don't want the div acting as a context menu to have a (browser) context menu!
    cxElement.addEventListener("contextmenu", e => {
        e.preventDefault();
        return false;
      }, false);
  
      function hideCX() {
        if (window.myDiagram.currentTool instanceof go.ContextMenuTool) {
          window.myDiagram.currentTool.doCancel();
        }
      }
  
      function showContextMenu(obj, diagram, tool) {
        // Show only the relevant buttons given the current state.
        var cmd = diagram.commandHandler;
        var hasMenuItem = false;
        function maybeShowItem(elt, pred) {
          if (pred) {
            elt.style.display = "block";
            hasMenuItem = true;
          } else {
            elt.style.display = "none";
          }
        }
        // maybeShowItem(document.getElementById("cut"), cmd.canCutSelection());
        // maybeShowItem(document.getElementById("copy"), cmd.canCopySelection());
        // maybeShowItem(document.getElementById("paste"), cmd.canPasteSelection(diagram.toolManager.contextMenuTool.mouseDownPoint));
        // maybeShowItem(document.getElementById("delete"), cmd.canDeleteSelection());
        // maybeShowItem(document.getElementById("color"), obj !== null);
  
        // Now show the whole context menu element
        if (hasMenuItem) {
          cxElement.classList.add("show-menu");
          // we don't bother overriding positionContextMenu, we just do it here:
          var mousePt = diagram.lastInput.viewPoint;
          cxElement.style.left = mousePt.x + 5 + "px";
          cxElement.style.top = mousePt.y + "px";
        }
  
        // Optional: Use a `window` pointerdown listener with event capture to
        //           remove the context menu if the user clicks elsewhere on the page
        window.addEventListener("pointerdown", hideCX, true);
      }
  
      function hideContextMenu() {
        cxElement.classList.remove("show-menu");
        // Optional: Use a `window` pointerdown listener with event capture to
        //           remove the context menu if the user clicks elsewhere on the page
        window.removeEventListener("pointerdown", hideCX, true);
      }
  
    // define the default Node template
    window.myDiagram.nodeTemplate =
        $(go.Node, "Auto", {
                click:nodeClicked,
                doubleClick: nodeDoubleClick,
                cursor:"pointer",
                contextMenu: myContextMenu,
                zOrder:10,
                // mouseEnter: (e, node) => node.findObject("BUTTON").opacity = node.findObject("BUTTONX").opacity = 1,
                // mouseLeave: (e, node) => node.findObject("BUTTON").opacity = node.findObject("BUTTONX").opacity = 0,
        
            // }, 
            // { // handle dragging a Node onto a Node to (maybe) change the reporting relationship
                mouseDragEnter: function(e, node, prev) {
                    var diagram = node.diagram;
                    var selnode = diagram.selection.first();
                    if (!mayWorkFor(selnode, node)) return;
                    var shape = node.findObject("SHAPE");
                    if (shape) {
                        shape._prevFill = shape.fill; // remember the original brush
                        shape.fill = "darkred";
                    }
                },
                mouseDragLeave: function(e, node, next) {
                    var shape = node.findObject("SHAPE");
                    if (shape && shape._prevFill) {
                        shape.fill = shape._prevFill; // restore the original brush
                    }
                },
                mouseDrop: function(e, node) {
                    var diagram = node.diagram;
                    var selnode = diagram.selection.first(); // assume just one Node in selection

                    // if the SHIFT key is not pressed, then just change the reporting lines
                    // this is the standard gojs behavior
                    if (window.shift_key_pressed == false) {
                        if (mayWorkFor(selnode, node)) {
                            // find any existing link into the selected node
                            var link = selnode.findTreeParentLink();
                            if (link !== null) { // reconnect any existing link
                                link.fromNode = node;
                            } else { // else create a new link
                                diagram.toolManager.linkingTool.insertLink(node, node.port, selnode, selnode.port);
                            }
                            window.myDiagram.clearSelection()
                        }
                    // instead, if the SHIFT key is pressed, bundle the two nodes together
                    } else {
                        bundlePeople(node, selnode)
                    }
                }
            },
            
            // for sorting, have the Node.text be the data.name
            // new go.Binding("text", "name"),
            // bind the Part.layerName to control the Node's layer depending on whether it isSelected
            // new go.Binding("layerName", "isSelected", function(sel) {
            //     return sel ? "Foreground" : "";
            // }).ofObject(),
            // define the node's outer shape


            // $(go.Shape, "RoundedRectangle",{  fill: 'white',  strokeWidth: 1, stroke: 'black', width: 220, alignment: new go.Spot(0.5, 0.5, -4, 4), height:  fetchNodeHeightforBackdrop   },
            // // new go.Binding("height", "candidates", showHeightLabelContainer)
            // ),
            // $(go.Shape, "RoundedRectangle",{  name:"backdrop_shape",fill: 'white', height:  fetchNodeHeightforBackdrop, strokeWidth: 1, stroke: 'black', width: 220},
            // new go.Binding("height", "candidates", showHeightLabelContainer)
                // new go.Binding("height", "height_0", fetchNodeHeightforBackdrop),

            // ),


            // This is needed for ensuring that the search nodes are selected when the search key is entered.
            // $(go.Shape, "RoundedRectangle",{  name:"SHAPE",fill: 'white', strokeWidth: 1, stroke: 'black', width: 220},
            //     // new go.Binding("height", "candidates", showHeightLabelContainer)
            //     // new go.Binding("height", "height_0", fetchNodeHeightforBackdrop),
            //     new go.Binding("stroke", "isHighlighted", function(h) { return h ? "blue" : "rgb(150,150, 150)"; }).ofObject(),
            //     new go.Binding("strokeWidth", "isHighlighted", function(h) { return h ? 5 : 1; }).ofObject(),
            //     new go.Binding("fill", "special_color")

            // ),



// Have disabled this to not show the double node
            // $(go.Shape, "RoundedRectangle", {
            //     name: "SHAPE",
            //     fill: "white",
            //     strokeWidth: 1,
            //     stroke: 'rgb(150,150, 150)', //  note: the border color is not set here, search for shape.stroke instead
            //     cursor: "pointer",
            //     width: 240,
            //     // stretch: go.GraphObject.Fill,
            //     margin: new go.Margin(0, 0, -5, -5),

            //     alignment: new go.Spot(5, 40, 40, 30),
            //     },

            //     // Adding this to edit stroke
            //     // new go.Binding("stroke", "isHighlighted", function(h) { return h ? "blue" : "rgb(150,150, 150)"; }).ofObject(),	
            // ),

            
            $(go.Panel, "Auto",



            
                $(go.Shape, "RoundedRectangle", {
                    name: "SHAPE",
                    fill: "white",
                    strokeWidth: 1,
                    stroke: 'rgb(150,150, 150)', //  note: the border color is not set here, search for shape.stroke instead
                    // set the port properties:
                    // portId: "",
                    //fromLinkable: true,
                    //toLinkable: true,
                    cursor: "pointer",
                    width: 230,
                    // alignment: new go.Spot(0.5, 0.5, -4, 4),
                    // zOrder:1
                    },
                    new go.Binding("stroke", "isHighlighted", function(h) { return h ? "blue" : "rgb(150,150, 150)"; }).ofObject(),
                    new go.Binding("strokeWidth", "isHighlighted", function(h) { return h ? 5 : 1; }).ofObject(),
                    new go.Binding("fill", "special_color")
                
                ),


                $(go.Panel, "Table", {

                    width: 220
                    },
                    $(go.RowColumnDefinition, {
                        column: 1,
                        width: 4
                    }),

                    

                    // This is for label
                    $(go.Shape, "RoundedRectangle", {
                        name: "LABEL",
                        fill: "rgb(36,116,204)",
                        height: 20, // will switch to 20 when there is a label
                        width: 60,
                        stroke: "rgba(255,255,255,0)",
                        // text: "Preview",

                        margin: new go.Margin(0, -90, 0, 0),
                        },
                    // $(go.TextBlock, textStyle(), {
                        //     row: 0,
                        //     column: 0,
                        //     font: "bold 11pt Segoe UI,sans-serif",
                        //     editable: false,
                        //     isMultiline: false,
                        //     // width: 200,
                        //     //wrap: go.TextBlock.WrapDesiredSize,
                        //     textAlign: "center",
                        //     text: "Preview",
                        //     stroke: "white",
                        // },
                        // new go.Binding("text", "label", textLabel)),
                        new go.Binding("height", "label", showLabelContainer),
                    // new go.Binding("fill", "label", colorLabel),                
                    ),

                    // This is for label
                    $(go.Panel, "Table", {
                        //width: 220,
                        height: 30, // will switch to 30 when there is a label
                        margin: new go.Margin(0, -90, 0, 0),
                        },
                        new go.Binding("height", "label", showLabelContainerTable),
                        
                        $(go.TextBlock, textStyle(), {
                                row: 0,
                                column: 0,
                                font: "bold 11pt Segoe UI,sans-serif",
                                editable: false,
                                isMultiline: false,
                                // width: 200,
                                //wrap: go.TextBlock.WrapDesiredSize,
                                textAlign: "center",
                                text: "Preview",
                                stroke: "white",
                            },
                            new go.Binding("text", "label", textLabel)),


                    ),

                    // This is headline
                    $(go.TextBlock, textStyle(), {
                            row: 2,
                            column: 0,
                            font: "bold 12pt Segoe UI,sans-serif",
                            editable: false,
                            isMultiline: false,
                            minSize: new go.Size(10, 14),
                            margin: new go.Margin(0, 5, 5, 5),
                            width: 200,
                            wrap: go.TextBlock.WrapFit,
                            textAlign: "center"
                        },
                        new go.Binding("text", "headline").makeTwoWay()),

                    // This is h0
                        $(go.Panel, "Horizontal", {
                            row: 4,
                            column: 0,
                            alignment: go.Spot.Left
                        },
                        new go.Binding("height", "height_0", findSize),


                        $(go.Panel, "Spot", {
                                isClipping: true,
                                scale: 1,
                                margin: new go.Margin(6, 8, 6, 10),
                                },
                        $(go.Shape, "Circle", { width: 30, strokeWidth: 0 } ),
                        $(go.Picture, {
                                sourceCrossOrigin: function() { return "anonymous"; },
                                name: "Picture",
                                desiredSize: new go.Size(30, 30),
                                errorFunction: function(pic, err) {
                                    window.myDiagram.model.setDataProperty(pic, "source", "https://st2.depositphotos.com/4111759/12123/v/950/depositphotos_121232442-stock-illustration-male-default-placeholder-avatar-profile.jpg");

                                },
                            },
                            new go.Binding("source", "image_0", loadImage))
                        ),

                        // define the panel where the text will appear
                        $(go.Panel, "Table",
                            {
                                margin: new go.Margin(0, 0, 0, 0),
                                defaultAlignment: go.Spot.Left,
                            },
                            $(go.TextBlock, textStyle(), // the name
                                {
                                    name: "NAMETB",
                                    row: 0,
                                    column: 0,
                                    font: "12pt Segoe UI,sans-serif",
                                    editable: false,
                                    isMultiline: false,
                                    minSize: new go.Size(5, 16),
                                    width: 150,
                                },
                                new go.Binding("text", "name_0").makeTwoWay()),


                            $(go.TextBlock, textStyle(), {
                                    row: 1,
                                    column: 0,
                                    editable: false,
                                    isMultiline: false,
                                    minSize: new go.Size(10, 14),
                                    margin: new go.Margin(0, 0, 0, 0),
                                    stroke: "rgb(150,150,150)",
                                    width: 150,
                                },
                                new go.Binding("text", "title_0").makeTwoWay()),

                            $(go.Picture, {
                                    name: "Picture",
                                    row: 1,
                                    column: 1,
                                    desiredSize: new go.Size(12, 12),
                                    alignment: go.Spot.Right,
                                    click: fetchNodeContextMenuClickedResults,
                                    "_buttonID": "findLockLogo",
                                    // click: function(e, obj) {getLinkedinUrl(obj.part.data.name_0, obj.part.data.title_0, obj.part.data.url_0, obj.part.data.image_0)},  //window.open(obj.part.data.url_0)
                                    margin: new go.Margin(0, 5, 0, 0),
                                    cursor: "pointer",
                                    width: 12,
                                },
                                new go.Binding("source", "key", findLockLogo)),


                            // define the panel where the text will appear
                        ) // end Table Panel
                    ), // end Horizontal Panel

                    // This is h1
                    $(go.Panel, "Horizontal", {
                            row: 5,
                            column: 0,
                            alignment: go.Spot.Left
                        },
                        new go.Binding("height", "height_1", findSize),

                        $(go.Panel, "Spot", {
                                isClipping: true,
                                scale: 1,
                                margin: new go.Margin(6, 8, 6, 10),
                                },
                        $(go.Shape, "Circle", { width: 30, strokeWidth: 0 } ),
                        $(go.Picture, {
                                sourceCrossOrigin: function() { return "anonymous"; },
                                name: "Picture",
                                desiredSize: new go.Size(30, 30),
                                errorFunction: function(pic, err) {
                                    window.myDiagram.model.setDataProperty(pic, "source", "https://st2.depositphotos.com/4111759/12123/v/950/depositphotos_121232442-stock-illustration-male-default-placeholder-avatar-profile.jpg");
                                },
                            },
                            new go.Binding("source", "image_1", loadImage))
                        ),

                        // define the panel where the text will appear
                        $(go.Panel, "Table",
                            {
                                margin: new go.Margin(0, 0, 0, 0),
                                defaultAlignment: go.Spot.Left
                            },
                            $(go.TextBlock, textStyle(), // the name
                                {
                                    name: "NAMETB",
                                    row: 0,
                                    column: 0,
                                    font: "12pt Segoe UI,sans-serif",
                                    editable: false,
                                    isMultiline: false,
                                    minSize: new go.Size(5, 16),
                                    width: 150,
                                },
                                new go.Binding("text", "name_1").makeTwoWay()),

                            $(go.Picture, {
                                    name: "Picture",
                                    row: 1,
                                    column: 1,
                                    desiredSize: new go.Size(12, 12),
                                    alignment: go.Spot.Right,
                                    click: fetchNodeContextMenuClickedResults,
                                    "_buttonID": "findLockLogo",
                                    // click: function(e, obj) {getLinkedinUrl(obj.part.data.name_1, obj.part.data.title_1, obj.part.data.url_1, obj.part.data.image_1)},  //window.open(obj.part.data.url_1)
                                    margin: new go.Margin(0, 5, 0, 0),
                                    cursor: "pointer",
                                    width: 12,
                                },
                                new go.Binding("source", "key", findLockLogo)),

                            $(go.TextBlock, textStyle(), {
                                    row: 1,
                                    column: 0,
                                    editable: false,
                                    isMultiline: false,
                                    minSize: new go.Size(10, 14),
                                    margin: new go.Margin(0, 0, 0, 0),
                                    stroke: "rgb(150,150,150)",
                                    width: 150,
                                },
                                new go.Binding("text", "title_1").makeTwoWay()),
                            // define the panel where the text will appear
                        ) // end Table Panel
                    ), // end Horizontal Panel

                    // This is h2
                    $(go.Panel, "Horizontal", {
                            row: 6,
                            column: 0,
                            alignment: go.Spot.Left
                        },
                        new go.Binding("height", "height_2", findSize),

                        $(go.Panel, "Spot", {
                                isClipping: true,
                                scale: 1,
                                margin: new go.Margin(6, 8, 6, 10),
                                },
                        $(go.Shape, "Circle", { width: 30, strokeWidth: 0 } ),
                        $(go.Picture, {
                                sourceCrossOrigin: function() { return "anonymous"; },
                                name: "Picture",
                                desiredSize: new go.Size(30, 30),
                                errorFunction: function(pic, err) {
                                    window.myDiagram.model.setDataProperty(pic, "source", "https://st2.depositphotos.com/4111759/12123/v/950/depositphotos_121232442-stock-illustration-male-default-placeholder-avatar-profile.jpg");
                                },
                            },
                            new go.Binding("source", "image_2", loadImage))
                        ),

                        // define the panel where the text will appear
                        $(go.Panel, "Table",
                            {
                                margin: new go.Margin(0, 0, 0, 0),
                                defaultAlignment: go.Spot.Left
                            },
                            $(go.TextBlock, textStyle(), // the name
                                {
                                    name: "NAMETB",
                                    row: 0,
                                    column: 0,
                                    font: "12pt Segoe UI,sans-serif",
                                    editable: false,
                                    isMultiline: false,
                                    minSize: new go.Size(5, 16),
                                    width: 150,
                                },
                                new go.Binding("text", "name_2").makeTwoWay()),

                            $(go.Picture, {
                                    name: "Picture",
                                    row: 1,
                                    column: 1,
                                    desiredSize: new go.Size(12, 12),
                                    alignment: go.Spot.Right,
                                    click: fetchNodeContextMenuClickedResults,
                                    "_buttonID": "findLockLogo",
                                    // click: function(e, obj) {getLinkedinUrl(obj.part.data.name_2, obj.part.data.title_2, obj.part.data.url_2, obj.part.data.image_2)},  //window.open(obj.part.data.url_2)
                                    margin: new go.Margin(0, 5, 0, 0),
                                    cursor: "pointer",
                                    width: 12,
                                },
                                new go.Binding("source", "key", findLockLogo)),

                            $(go.TextBlock, textStyle(), {
                                    row: 1,
                                    column: 0,
                                    editable: false,
                                    isMultiline: false,
                                    minSize: new go.Size(10, 14),
                                    margin: new go.Margin(0, 0, 0, 0),
                                    stroke: "rgb(150,150,150)",
                                    width: 150,
                                },
                                new go.Binding("text", "title_2").makeTwoWay()),
                            // define the panel where the text will appear
                        ) // end Table Panel
                    ), // end Horizontal Panel

                    // This is h3
                    $(go.Panel, "Horizontal", {
                            row: 7,
                            column: 0,
                            alignment: go.Spot.Left
                        },
                        new go.Binding("height", "height_3", findSize),

                        $(go.Panel, "Spot", {
                                isClipping: true,
                                scale: 1,
                                margin: new go.Margin(6, 8, 6, 10),
                                },
                        $(go.Shape, "Circle", { width: 30, strokeWidth: 0 } ),
                        $(go.Picture, {
                                sourceCrossOrigin: function() { return "anonymous"; },
                                name: "Picture",
                                desiredSize: new go.Size(30, 30),
                                errorFunction: function(pic, err) {
                                    window.myDiagram.model.setDataProperty(pic, "source", "https://st2.depositphotos.com/4111759/12123/v/950/depositphotos_121232442-stock-illustration-male-default-placeholder-avatar-profile.jpg");
                                },
                            },
                            new go.Binding("source", "image_3", loadImage))
                        ),

                        // define the panel where the text will appear
                        $(go.Panel, "Table",
                            {
                                margin: new go.Margin(0, 0, 0, 0),
                                defaultAlignment: go.Spot.Left
                            },
                            $(go.TextBlock, textStyle(), // the name
                                {
                                    name: "NAMETB",
                                    row: 0,
                                    column: 0,
                                    font: "12pt Segoe UI,sans-serif",
                                    editable: false,
                                    isMultiline: false,
                                    minSize: new go.Size(5, 16),
                                    width: 150,
                                },
                                new go.Binding("text", "name_3").makeTwoWay()),

                            $(go.Picture, {
                                    name: "Picture",
                                    row: 1,
                                    column: 1,
                                    desiredSize: new go.Size(12, 12),
                                    alignment: go.Spot.Right,
                                    click: fetchNodeContextMenuClickedResults,
                                    "_buttonID": "findLockLogo",
                                    // click: function(e, obj) {getLinkedinUrl(obj.part.data.name_3, obj.part.data.title_3, obj.part.data.url_3, obj.part.data.image_3)},  //window.open(obj.part.data.url_3)
                                    margin: new go.Margin(0, 5, 0, 0),
                                    cursor: "pointer",
                                    width: 12,
                                },
                                new go.Binding("source", "key", findLockLogo)),

                            $(go.TextBlock, textStyle(), {
                                    row: 1,
                                    column: 0,
                                    editable: false,
                                    isMultiline: false,
                                    minSize: new go.Size(10, 14),
                                    margin: new go.Margin(0, 0, 0, 0),
                                    stroke: "rgb(150,150,150)",
                                    width: 150,
                                },
                                new go.Binding("text", "title_3").makeTwoWay())
                            // define the panel where the text will appear

                        ) // end Table Panel
                    ), // end Horizontal Panel
                    
                    // Bottom boxes (download, etc)
                    $(go.Panel, "Horizontal", {
                            row: 8,
                            column: 0,
                            alignment: go.Spot.Right,
                            height: 40
                        },
                        // new go.Binding("height", "total_people", showSeeMore),

                        // define the panel where the text will appear
                        $(go.Panel, "Table",
                            {
                                margin: new go.Margin(0, 15, 0, 0),
                            },
                            // NOT SHOWING THE COUNTS OF PEOPLE IN BOXES TO AVOID CONFUSION FOR PEOPLE
                            // $(go.TextBlock, textStyle(), {
                            //         row: 0,
                            //         column: 1,
                            //         editable: false,
                            //         isMultiline: false,
                            //         minSize: new go.Size(10, 14),
                            //         margin: new go.Margin(0, 0, 0, 150),
                            //         stroke: "rgb(150,150,150)",
                            //         cursor: "pointer",
                            //         "_buttonID": "textSeeMoreCredits",

                            //         click: fetchNodeContextMenuClickedResults,
                            // },
                            // new go.Binding("text", "total_people", textSeeMoreCredits)),
                            // define the panel where the text will appear

                            $(go.Picture, {
                                name: "Picture",
                                row: 0,
                                column: 1,
                                desiredSize: new go.Size(12, 12),
                                alignment: go.Spot.Right,
                                // click: function(e, obj) {getLinkedinUrl(obj.part.data.name_2, obj.part.data.title_2, obj.part.data.url_2, obj.part.data.image_2)},  //window.open(obj.part.data.url_2)
                                click: fetchNodeContextMenuClickedResults,
                                "_buttonID": "findLockLogo",
                                margin: new go.Margin(0, 180, 0, 0),
                                cursor: "pointer",
                                width: 12,
                            },
                            new go.Binding("source", "key", findLockLogo)),

                            
                        ) // end Table Panel
                    ), // end Horizontal Panel

                ) // end Table Panel

                
            ),
            
            
            {
                contextMenu:     // define a context menu for each node
                  $("ContextMenu",  // that has one button
                    $("ContextMenuButton",
                      {
                        "ButtonBorder.fill": "white",
                        "_buttonFillOver": "skyblue",
                        "_buttonID": "fetchCurrentNodeDataResults"

                        // "alignment":"go.Spot.Left"
                      },
                      $(go.TextBlock, "Get people in this position"),
                      { click: fetchNodeContextMenuClickedResults}),
                      
                    $("ContextMenuButton",
                    {
                    "ButtonBorder.fill": "white",
                    "_buttonFillOver": "skyblue",
                    "_buttonID": "fetchAllSelectedNodes"
                    // "alignment":"go.Spot.Left"
                    },
                    $(go.TextBlock, "Get all in selected positions"),
                    { click: fetchNodeContextMenuClickedResults}),
                    
                    $("ContextMenuButton",
                    {
                    "ButtonBorder.fill": "white",
                    "_buttonFillOver": "skyblue",
                    "_buttonID": "boolean_keywords_string"
                    // "alignment":"go.Spot.Left"
                    },
                    $(go.TextBlock, "Get Boolean Keywords String"),
                    { click: fetchNodeContextMenuClickedResults}),
                    
        
                    
                    $("ContextMenuButton",
                    {
                    "ButtonBorder.fill": "white",
                    "_buttonFillOver": "skyblue",
                    "_buttonID": "fetchAllLeadershipNodes"
                    // "alignment":"go.Spot.Left"
                    },
                    $(go.TextBlock, "Get all leadership in this company"),
                    { click: fetchNodeContextMenuClickedResults}),

                    $("ContextMenuButton",
                    {
                    "ButtonBorder.fill": "white",
                    "_buttonFillOver": "skyblue",
                    "_buttonID": "fetchEntireCompanyDataResults"
                    // "alignment":"go.Spot.Left"
                    },
                    $(go.TextBlock, "Get all names in this company"),
                    { click: fetchNodeContextMenuClickedResults}),

                    
                    $("ContextMenuButton",
                    {
                    "ButtonBorder.fill": "white",
                    "_buttonFillOver": "skyblue",
                    "_buttonID": "fetchAllFunctionDataResults"

                    // "alignment":"go.Spot.Left"
                    },
                    $(go.TextBlock, "Get for all names in this function"),
                    { click: fetchNodeContextMenuClickedResults}),

                    $("ContextMenuButton",
                    {
                    "ButtonBorder.fill": "white",
                    "_buttonFillOver": "skyblue",
                    "_buttonID": "fetchCurrentPositionAcrossCompaniesResults"
                    // "alignment":"go.Spot.Left"
                    },

                    $(go.TextBlock, "Get similar names in similar companies"),
                    { click: fetchNodeContextMenuClickedResults}),
                    // $("ContextMenuButton",
                    // {
                    // "ButtonBorder.fill": "white",
                    // "_buttonFillOver": "skyblue",
                    // "_buttonID": "viewThisPositioninPeopleTab"
                    // // "alignment":"go.Spot.Left"
                    // },
                    // $(go.TextBlock, "View this position in people tab"),
                    // { click: fetchNodeContextMenuClickedResults}),

                    
                    
                    // more ContextMenuButtons would go here
                  )  // end Adornment
              }
  
    



        ); // end Node


	// Defining detailed Node Template
    // define the Node template
    var detailtemplate =
        $(go.Node, "Auto", {
                click:nodeClicked,
                doubleClick: function(e, obj) {new Modals().seeMoreModal(obj.part.data.key, obj.part.data.key)}
                // doubleClick: downloadExcel
            }, { // handle dragging a Node onto a Node to (maybe) change the reporting relationship
                mouseDragEnter: function(e, node, prev) {
                    var diagram = node.diagram;
                    var selnode = diagram.selection.first();
                    if (!mayWorkFor(selnode, node)) return;
                    var shape = node.findObject("SHAPE");
                    if (shape) {
                        shape._prevFill = shape.fill; // remember the original brush
                        shape.fill = "darkred";
                    }
                },
                mouseDragLeave: function(e, node, next) {
                    var shape = node.findObject("SHAPE");
                    if (shape && shape._prevFill) {
                        shape.fill = shape._prevFill; // restore the original brush
                    }
                },
                mouseDrop: function(e, node) {
                    var diagram = node.diagram;
                    var selnode = diagram.selection.first(); // assume just one Node in selection

                    // if the SHIFT key is not pressed, then just change the reporting lines
                    // this is the standard gojs behavior
                    if (window.shift_key_pressed == false) {
                        if (mayWorkFor(selnode, node)) {
                            // find any existing link into the selected node
                            var link = selnode.findTreeParentLink();
                            if (link !== null) { // reconnect any existing link
                                link.fromNode = node;
                            } else { // else create a new link
                                diagram.toolManager.linkingTool.insertLink(node, node.port, selnode, selnode.port);
                            }
                            window.myDiagram.clearSelection()
                        }
                    // instead, if the SHIFT key is pressed, bundle the two nodes together
                    } else {
                        bundlePeople(node, selnode)
                    }
                }
            },
            // for sorting, have the Node.text be the data.name
            new go.Binding("text", "name"),
            // bind the Part.layerName to control the Node's layer depending on whether it isSelected
            new go.Binding("layerName", "isSelected", function(sel) {
                return sel ? "Foreground" : "";
            }).ofObject(),
            // define the node's outer shape
            $(go.Shape, "RoundedRectangle", {
                name: "SHAPE",
                fill: "white",
                strokeWidth: 1,
                stroke: 'rgb(150,150, 150)', //  note: the border color is not set here, search for shape.stroke instead
                // set the port properties:
                portId: "",
                //fromLinkable: true,
                //toLinkable: true,
                cursor: "pointer",
                width: 220
            },
            new go.Binding("stroke", "isHighlighted", function(h) { return h ? "blue" : "rgb(150,150, 150)"; }).ofObject(),
            new go.Binding("strokeWidth", "isHighlighted", function(h) { return h ? 5 : 1; }).ofObject(),
            new go.Binding("fill", "special_color")),


            $(go.Panel, "Table", {
                width: 220
                },
                $(go.RowColumnDefinition, {
                    column: 1,
                    width: 4
                }),

                // $(go.Picture, {
                //     name: "Picture",
                //     row: 1,
                //     column: 0,
                //     desiredSize: new go.Size(12, 12),
                //     alignment: go.Spot.Right,
                //     click: (e, node) => e.diagram.commandHandler.showContextMenu(node),
                //     margin: new go.Margin(0, 5, 0, 10),
                //     cursor: "pointer",
                //     width: 12,
                // },
                // new go.Binding("source", "key", findGreenIcon)),



                $(go.Shape, "RoundedRectangle", {
                    name: "LABEL",
                    fill: "PaleGreen",
                    height: 20, // will switch to 20 when there is a label
                    width: 60,
                    stroke: "rgba(255,255,255,0)",
                    margin: new go.Margin(0, -90, 0, 0),
                },
                new go.Binding("height", "label", showLabelContainer),
                // new go.Binding("fill", "label", colorLabel),
                ),
                $(go.Panel, "Table", {
                    //width: 220,
                    height: 30, // will switch to 30 when there is a label
                    margin: new go.Margin(0, -90, 0, 0),
                    },
                    new go.Binding("height", "label", showLabelContainerTable),

                    $(go.TextBlock, textStyle(), {
                            row: 0,
                            column: 0,
                            font: "bold 12pt Segoe UI,sans-serif",
                            editable: false,
                            isMultiline: false,
                            //width: 200,
                            //wrap: go.TextBlock.WrapDesiredSize,
                            textAlign: "center",
                            text: "Active",
                            stroke: "white",
                        },
                        // new go.Binding("text", "label", textLabel)
                        )

                ),
                $(go.TextBlock, textStyle(), {
                        row: 2,
                        column: 0,
                        font: "bold 12pt Segoe UI,sans-serif",
                        editable: false,
                        isMultiline: false,
                        minSize: new go.Size(10, 14),
                        margin: new go.Margin(0, 5, 5, 5),
                        width: 200,
                        wrap: go.TextBlock.WrapFit,
                        textAlign: "center"
                    },
                    new go.Binding("text", "headline").makeTwoWay()),

                $(go.TextBlock, textStyle(), {
                        row: 3,
                        column: 0,
                        editable: false,
                        isMultiline: false,
                        minSize: new go.Size(10, 14),
                        margin: new go.Margin(0, 5, 20, 5),
                        stroke: "rgb(150,150,150)"
                    },
                    new go.Binding("text", "country").makeTwoWay()),


                $(go.Panel, "Horizontal", {
                        row: 4,
                        column: 0,
                        alignment: go.Spot.Left
                    },
                    new go.Binding("height", "height_0", findSize),


                    $(go.Panel, "Spot", {
                            isClipping: true,
                            scale: 1,
                            margin: new go.Margin(6, 8, 6, 10),
                            },
                        $(go.Shape, "Circle", { width: 30, strokeWidth: 0 } ),
                    $(go.Picture, {
                            sourceCrossOrigin: function() { return "anonymous"; },
                            name: "Picture",
                            desiredSize: new go.Size(30, 30),
                            errorFunction: function(pic, err) {
                                window.myDiagram.model.setDataProperty(pic, "source", "https://st2.depositphotos.com/4111759/12123/v/950/depositphotos_121232442-stock-illustration-male-default-placeholder-avatar-profile.jpg");

                            },
                        },
                        new go.Binding("source", "image_0", loadImage))
                    ),

                    // define the panel where the text will appear
                    $(go.Panel, "Table",
                        {
                            margin: new go.Margin(0, 0, 0, 0),
                            defaultAlignment: go.Spot.Left,
                        },
                        $(go.TextBlock, textStyle(), // the name
                            {
                                name: "NAMETB",
                                row: 0,
                                column: 0,
                                font: "12pt Segoe UI,sans-serif",
                                editable: false,
                                isMultiline: false,
                                minSize: new go.Size(5, 16),
                                width: 150,
                            },
                            new go.Binding("text", "name_0").makeTwoWay()),


                        $(go.TextBlock, textStyle(), {
                                row: 1,
                                column: 0,
                                editable: false,
                                isMultiline: false,
                                minSize: new go.Size(10, 14),
                                margin: new go.Margin(0, 0, 0, 0),
                                stroke: "rgb(150,150,150)",
                                width: 150,
                            },
                            new go.Binding("text", "title_0").makeTwoWay()),

                        $(go.Picture, {
                                name: "Picture",
                                row: 1,
                                column: 1,
                                desiredSize: new go.Size(12, 12),
                                alignment: go.Spot.Right,
                                click: function(e, obj) {new UtilityFunctions().getLinkedinUrl(obj.part.data.name_0, obj.part.data.title_0, obj.part.data.linkedin_url_0, obj.part.data.image_0)},  //window.open(obj.part.data.url_0)
                                margin: new go.Margin(0, 5, 0, 0),
                                cursor: "pointer",
                                width: 12,
                            },
                            new go.Binding("source", "key", findLinkedinLogo)),


                        // define the panel where the text will appear
                    ) // end Table Panel
                ), // end Horizontal Panel

                $(go.Panel, "Horizontal", {
                        row: 5,
                        column: 0,
                        alignment: go.Spot.Left
                    },
                    new go.Binding("height", "height_1", findSize),

                    $(go.Panel, "Spot", {
                            isClipping: true,
                            scale: 1,
                            margin: new go.Margin(6, 8, 6, 10),
                            },
                        $(go.Shape, "Circle", { width: 30, strokeWidth: 0 } ),
                    $(go.Picture, {
                            sourceCrossOrigin: function() { return "anonymous"; },
                            name: "Picture",
                            desiredSize: new go.Size(30, 30),
                            errorFunction: function(pic, err) {
                                window.myDiagram.model.setDataProperty(pic, "source", "https://st2.depositphotos.com/4111759/12123/v/950/depositphotos_121232442-stock-illustration-male-default-placeholder-avatar-profile.jpg");
                            },
                        },
                        new go.Binding("source", "image_1", loadImage))
                    ),

                    // define the panel where the text will appear
                    $(go.Panel, "Table",
                        {
                            margin: new go.Margin(0, 0, 0, 0),
                            defaultAlignment: go.Spot.Left
                        },
                        $(go.TextBlock, textStyle(), // the name
                            {
                                name: "NAMETB",
                                row: 0,
                                column: 0,
                                font: "12pt Segoe UI,sans-serif",
                                editable: false,
                                isMultiline: false,
                                minSize: new go.Size(5, 16),
                                width: 150,
                            },
                            new go.Binding("text", "name_1").makeTwoWay()),

                        $(go.Picture, {
                                name: "Picture",
                                row: 1,
                                column: 1,
                                desiredSize: new go.Size(12, 12),
                                alignment: go.Spot.Right,
                                click: function(e, obj) {new UtilityFunctions().getLinkedinUrl(obj.part.data.name_1, obj.part.data.title_1, obj.part.data.linkedin_url_1, obj.part.data.image_1)},  //window.open(obj.part.data.url_1)
                                margin: new go.Margin(0, 5, 0, 0),
                                cursor: "pointer",
                                width: 12,
                            },
                            new go.Binding("source", "key", findLinkedinLogo)),

                        $(go.TextBlock, textStyle(), {
                                row: 1,
                                column: 0,
                                editable: false,
                                isMultiline: false,
                                minSize: new go.Size(10, 14),
                                margin: new go.Margin(0, 0, 0, 0),
                                stroke: "rgb(150,150,150)",
                                width: 150,
                            },
                            new go.Binding("text", "title_1").makeTwoWay()),
                        // define the panel where the text will appear
                    ) // end Table Panel
                ), // end Horizontal Panel

                $(go.Panel, "Horizontal", {
                        row: 6,
                        column: 0,
                        alignment: go.Spot.Left
                    },
                    new go.Binding("height", "height_2", findSize),

                    $(go.Panel, "Spot", {
                            isClipping: true,
                            scale: 1,
                            margin: new go.Margin(6, 8, 6, 10),
                            },
                        $(go.Shape, "Circle", { width: 30, strokeWidth: 0 } ),
                    $(go.Picture, {
                            sourceCrossOrigin: function() { return "anonymous"; },
                            name: "Picture",
                            desiredSize: new go.Size(30, 30),
                            errorFunction: function(pic, err) {
                                window.myDiagram.model.setDataProperty(pic, "source", "https://st2.depositphotos.com/4111759/12123/v/950/depositphotos_121232442-stock-illustration-male-default-placeholder-avatar-profile.jpg");
                            },
                        },
                        new go.Binding("source", "image_2", loadImage))
                    ),

                    // define the panel where the text will appear
                    $(go.Panel, "Table",
                        {
                            margin: new go.Margin(0, 0, 0, 0),
                            defaultAlignment: go.Spot.Left
                        },
                        $(go.TextBlock, textStyle(), // the name
                            {
                                name: "NAMETB",
                                row: 0,
                                column: 0,
                                font: "12pt Segoe UI,sans-serif",
                                editable: false,
                                isMultiline: false,
                                minSize: new go.Size(5, 16),
                                width: 150,
                            },
                            new go.Binding("text", "name_2").makeTwoWay()),

                        $(go.Picture, {
                                name: "Picture",
                                row: 1,
                                column: 1,
                                desiredSize: new go.Size(12, 12),
                                alignment: go.Spot.Right,
                                click: function(e, obj) {new UtilityFunctions().getLinkedinUrl(obj.part.data.name_2, obj.part.data.title_2, obj.part.data.linkedin_url_2, obj.part.data.image_2)},  //window.open(obj.part.data.url_2)
                                margin: new go.Margin(0, 5, 0, 0),
                                cursor: "pointer",
                                width: 12,
                            },
                            new go.Binding("source", "key", findLinkedinLogo)),

                        $(go.TextBlock, textStyle(), {
                                row: 1,
                                column: 0,
                                editable: false,
                                isMultiline: false,
                                minSize: new go.Size(10, 14),
                                margin: new go.Margin(0, 0, 0, 0),
                                stroke: "rgb(150,150,150)",
                                width: 150,
                            },
                            new go.Binding("text", "title_2").makeTwoWay()),
                        // define the panel where the text will appear
                    ) // end Table Panel
                ), // end Horizontal Panel

                $(go.Panel, "Horizontal", {
                        row: 7,
                        column: 0,
                        alignment: go.Spot.Left
                    },
                    new go.Binding("height", "height_3", findSize),

                    $(go.Panel, "Spot", {
                            isClipping: true,
                            scale: 1,
                            margin: new go.Margin(6, 8, 6, 10),
                            },
                        $(go.Shape, "Circle", { width: 30, strokeWidth: 0 } ),
                    $(go.Picture, {
                            sourceCrossOrigin: function() { return "anonymous"; },
                            name: "Picture",
                            desiredSize: new go.Size(30, 30),
                            errorFunction: function(pic, err) {
                                window.myDiagram.model.setDataProperty(pic, "source", "https://st2.depositphotos.com/4111759/12123/v/950/depositphotos_121232442-stock-illustration-male-default-placeholder-avatar-profile.jpg");
                            },
                        },
                        new go.Binding("source", "image_3", loadImage))
                    ),

                    // define the panel where the text will appear
                    $(go.Panel, "Table",
                        {
                            margin: new go.Margin(0, 0, 0, 0),
                            defaultAlignment: go.Spot.Left
                        },
                        $(go.TextBlock, textStyle(), // the name
                            {
                                name: "NAMETB",
                                row: 0,
                                column: 0,
                                font: "12pt Segoe UI,sans-serif",
                                editable: false,
                                isMultiline: false,
                                minSize: new go.Size(5, 16),
                                width: 150,
                            },
                            new go.Binding("text", "name_3").makeTwoWay()),

                        $(go.Picture, {
                                name: "Picture",
                                row: 1,
                                column: 1,
                                desiredSize: new go.Size(12, 12),
                                alignment: go.Spot.Right,
                                click: function(e, obj) {new UtilityFunctions().getLinkedinUrl(obj.part.data.name_3, obj.part.data.title_3, obj.part.data.linkedin_url_3, obj.part.data.image_3)},  //window.open(obj.part.data.url_3)
                                margin: new go.Margin(0, 5, 0, 0),
                                cursor: "pointer",
                                width: 12,
                            },
                            new go.Binding("source", "key", findLinkedinLogo)),

                        $(go.TextBlock, textStyle(), {
                                row: 1,
                                column: 0,
                                editable: false,
                                isMultiline: false,
                                minSize: new go.Size(10, 14),
                                margin: new go.Margin(0, 0, 0, 0),
                                stroke: "rgb(150,150,150)",
                                width: 150,
                            },
                            new go.Binding("text", "title_3").makeTwoWay())
                        // define the panel where the text will appear

                    ) // end Table Panel
                ), // end Horizontal Panel

                $(go.Panel, "Horizontal", {
                        row: 8,
                        column: 0,
                        alignment: go.Spot.Right,
                        height:40
                    },
                    new go.Binding("height", "total_people", showSeeMore),

                    // define the panel where the text will appear
                    $(go.Panel, "Table",
                        {
                            margin: new go.Margin(0, 15, 0, 0),
                        },

                        $(go.TextBlock, textStyle(), {
                            row: 0,
                            column: 1,
                            editable: false,
                            isMultiline: false,
                            minSize: new go.Size(10, 14),
                            margin: new go.Margin(0, 0, 0, 150),
                            stroke: "rgb(150,150,150)",
                            cursor: "pointer",
                //         "_buttonID": "textSeeMoreCredits",

                            click: function(e, obj) {new Modals().seeMoreModal(obj.part.data.key, obj.part.data.key)},
                        },
                                                // new go.Binding("text", "total_people", textSeeMoreCredits)),

                        new go.Binding("text", "total_people", textSeeMore)),
                        $(go.Picture, {
                            name: "Picture",
                            row: 0,
                            column: 1,
                            desiredSize: new go.Size(12, 12),
                            alignment: go.Spot.Right,
                            click: downloadExcel,
                            margin: new go.Margin(0, 180, 0, 0),
                            cursor: "pointer",
                            width: 12,
                        },
                        // new go.Binding("source", "key", findLockLogo)),
                        new go.Binding("source", "key", findDownloadIcon)),


                        $(go.Picture, {
                            name: "Picture",
                            row: 0,
                            column: 1,
                            desiredSize: new go.Size(12, 12),
                            alignment: go.Spot.Right,
                            click: fetchSimilarPeople,
                            margin: new go.Margin(0, 150, 0, 0),
                            cursor: "pointer",
                            width: 12,
                        },
                        // new go.Binding("source", "key", findLockLogo)),
                        new go.Binding("source", "key", findSimilarItemsIcon)),


                    
                    ) // end Table Panel
                ), // end Horizontal Panel
        )
    ); // end Node



	// Defining detailed Node Template
    // define the Node template
    var sideAssistantTemplate =
        $(go.Node, "Auto", {
            doubleClick:sideAssistantNodeClicked,
            // click: fetchNodeContextMenuClickedResults
             segmentIndex: -2,
             zOrder:-2


                // doubleClick: nodeDoubleClick
            }, { // handle dragging a Node onto a Node to (maybe) change the reporting relationship
                mouseDragEnter: function(e, node, prev) {
                    var diagram = node.diagram;
                    var selnode = diagram.selection.first();
                    if (!mayWorkFor(selnode, node)) return;
                    var shape = node.findObject("SHAPE");
                    if (shape) {
                        shape._prevFill = shape.fill; // remember the original brush
                        shape.fill = "darkred";
                    }
                },
                mouseDragLeave: function(e, node, next) {
                    var shape = node.findObject("SHAPE");
                    if (shape && shape._prevFill) {
                        shape.fill = shape._prevFill; // restore the original brush
                    }
                },
                mouseDrop: function(e, node) {
                    var diagram = node.diagram;
                    var selnode = diagram.selection.first(); // assume just one Node in selection

                    // if the SHIFT key is not pressed, then just change the reporting lines
                    // this is the standard gojs behavior
                    if (window.shift_key_pressed == false) {
                        if (mayWorkFor(selnode, node)) {
                            // find any existing link into the selected node
                            var link = selnode.findTreeParentLink();
                            if (link !== null) { // reconnect any existing link
                                link.fromNode = node;
                            } else { // else create a new link
                                diagram.toolManager.linkingTool.insertLink(node, node.port, selnode, selnode.port);
                            }
                            window.myDiagram.clearSelection()
                        }
                    // instead, if the SHIFT key is pressed, bundle the two nodes together
                    } else {
                        bundlePeople(node, selnode)
                    }
                }
            },
            // for sorting, have the Node.text be the data.name
            new go.Binding("text", "name"),
            // bind the Part.layerName to control the Node's layer depending on whether it isSelected
            new go.Binding("layerName", "isSelected", function(sel) {
                return sel ? "Foreground" : "";
            }).ofObject(),
            // define the node's outer shape
            $(go.Shape, "RoundedRectangle", {
                name: "SHAPE",
                fill: "white",
                strokeWidth: 1,
                stroke: 'rgb(150,150, 150)', //  note: the border color is not set here, search for shape.stroke instead
                // set the port properties:
                portId: "",
                //fromLinkable: true,
                //toLinkable: true,
                cursor: "pointer",
                width: 150
            },
            new go.Binding("stroke", "isHighlighted", function(h) { return h ? "blue" : "rgb(150,150, 150)"; }).ofObject(),
            new go.Binding("strokeWidth", "isHighlighted", function(h) { return h ? 5 : 1; }).ofObject(),
            new go.Binding("fill", "special_color")),


            $(go.Panel, "Table", {
                width: 150
                },
                $(go.RowColumnDefinition, {
                    column: 1,
                    width: 4
                }),

                $(go.Shape, "RoundedRectangle", {
                    name: "LABEL",
                    fill: "rgb(102,204,255)",
                    height: 0, // will switch to 20 when there is a label
                    width: 110,
                    stroke: "rgba(255,255,255,0)",
                    margin: new go.Margin(0, -90, 0, 0),
                },
                new go.Binding("height", "label", showLabelContainer),
                new go.Binding("fill", "label", colorLabel),
                ),
                $(go.Panel, "Table", {
                    //width: 220,
                    height: 30, // will switch to 30 when there is a label
                    margin: new go.Margin(0, -90, 0, 0),
                    },
                new go.Binding("height", "label", showLabelContainerTable),


                ),
                $(go.TextBlock, textStyle(), {
                        row: 4,
                        column: 0,
                        // text: "GOt to do",
                        font: "bold 12pt Segoe UI,sans-serif",
                        editable: false,
                        isMultiline: false,
                        minSize: new go.Size(10, 14),
                        margin: new go.Margin(0, 0, 0, 0),
                        width: 150,
                        textAlign: "center"
                    },
                new go.Binding("text", "headline").makeTwoWay()),

                
                $(go.Picture, {
                    name: "Picture",
                    row: 3,
                    column: 0,
                    // desiredSize: new go.Size(25, 25),
                    alignment: go.Spot.Center,
                    // click: fetchSimilarPeople,
                    margin: new go.Margin(10, 0, 25, 0),
                    cursor: "pointer",
                    width: 40,
                },
                new go.Binding("source", "key", findPlusIcon)),

                $(go.Panel, "Horizontal", {
                        row: 8,
                        column: 0,
                        alignment: go.Spot.Right,
                        height:10
                    },
                    new go.Binding("height", "total_people", showSeeMore),

                    // define the panel where the text will appear
                    $(go.Panel, "Table",
                        {
                            margin: new go.Margin(10, 15, 0, 0),
                        },
                    ) // end Table Panel
                ), // end Horizontal Panel
        ),
    ); // end Node



    sideAssistantTemplate.contextMenu = 
        $("ContextMenu",
            $("ContextMenuButton",
            {
                "ButtonBorder.fill": "white",
                "_buttonFillOver": "skyblue",
                "_buttonID": "fetchNodeFunctionGradeDataResults"
                // "alignment":"go.Spot.Left"
            },
            $(go.TextBlock, "Get profiles in this function"), {
                click: function(e, obj) {
                    // reparent the subtree to this node's boss, then remove the node
                    // var node = obj.part.adornedPart;
                    // 
                    // fetchSimilarPeople(e,obj)
                    fetchNodeContextMenuClickedResults(e,obj)
                }, 
                
            },
            // new go.Binding("text", "", function(e, obj) {return getTextDisplayForAssistantTemplate(e)}),
            new go.Binding("visible", "", function(e, obj) {return showIfSelectionIsNotMultiple(e)})
            ),
            

            );

        // function getTextDisplayForAssistantTemplate(e,obj){
        //     console.log("This is the obj key::", obj.part.data.key)
            
        //     return "Get people in this function with a panda"
        // }
    
        // the context menu allows users to make a position vacant,
    // remove a role and reassign the subtree, or remove a department
    detailtemplate.contextMenu =
        $("ContextMenu",

        $("ContextMenuButton",
        {
        "ButtonBorder.fill": "white",
        "_buttonFillOver": "skyblue",
        "_buttonID": "Show All People"
        // "alignment":"go.Spot.Left"
        },

        $(go.TextBlock, "Show people"),
        { click: function(e, obj) {new Modals().seeMoreModal(obj.part.data.key, obj.part.data.key)}}),

        $("ContextMenuButton",
        {
          "ButtonBorder.fill": "white",
          "_buttonFillOver": "skyblue",
          "_buttonID": "fetchCurrentNodeDataResults"

          // "alignment":"go.Spot.Left"
        },
        $(go.TextBlock, "Get people in this position"),
        { click: fetchNodeContextMenuClickedResults}),




        $("ContextMenuButton",
        {
            "ButtonBorder.fill": "white",
            "_buttonFillOver": "skyblue",
            "_buttonID": "fetchSimilarPeopleinThisCompany"
            // "alignment":"go.Spot.Left"
        },
        $(go.TextBlock, "Get Similar People in this company"), {
            click: function(e, obj) {
                // reparent the subtree to this node's boss, then remove the node
                var node = obj.part.adornedPart;
                // 
                fetchSimilarPeople(e,obj)
            }
        },
        new go.Binding("visible", "", function(e, obj) {return showIfSelectionIsNotMultiple(e)})
        ),
        $("ContextMenuButton",
        {
        "ButtonBorder.fill": "white",
        "_buttonFillOver": "skyblue",
        "_buttonID": "fetchCurrentPositionAcrossCompaniesResults"
        // "alignment":"go.Spot.Left"
        },

        $(go.TextBlock, "Get similar people in similar companies"),
        { click: fetchNodeContextMenuClickedResults}),
        $("ContextMenuButton",
        {
        "ButtonBorder.fill": "white",
        "_buttonFillOver": "skyblue",
        "_buttonID": "boolean_keywords_string"
        // "alignment":"go.Spot.Left"
        },

        $(go.TextBlock, "Get Boolean Keywords String"),
        { click: fetchNodeContextMenuClickedResults}),

        $("ContextMenuButton",
        {
        "ButtonBorder.fill": "white",
        "_buttonFillOver": "skyblue",
        "_buttonID": "downloadNodeDatatoExcel"
        // "alignment":"go.Spot.Left"
        },

        $(go.TextBlock, "Download to Excel"),
        { click: downloadNodeDatatoExcel}),

        );




        
	var templMap = new go.Map()
	// templMap.add("simple", simpletemplate)
	// Adding detailed template here
	templMap.add("detailed", detailtemplate)
	templMap.add("sideAssistant", sideAssistantTemplate)
	// Default template with ""
	templMap.add("", window.myDiagram.nodeTemplate) 

	// committing to my diagram
	window.myDiagram.nodeTemplateMap = templMap

    // define the Link template
    window.myDiagram.linkTemplate =
        $(go.Link, go.Link.Orthogonal, {
                corner: 5,
                relinkableFrom: true,
                relinkableTo: true
            },
            $(go.Shape, {
                strokeWidth: 4,
                stroke: "#00a4a4"
            })); // the link shape

    // read in the JSON-format data from the "mySavedModel" element
    //load();


    // support editing the properties of the selected person in HTML
    if (window.Inspector) myInspector = new Inspector("myInspector", window.myDiagram, {
        properties: {
            "key": {
                readOnly: true
            },
            "comments": {},
            "isAssistant": {
                type: "boolean"
            }
        },
        propertyModified: function(name, val) {
            if (name === "isAssistant") window.myDiagram.layout.invalidateLayout();
        }
    });

      // Setup zoom to fit button
    //   document.getElementById('zoomToFit').addEventListener('click', function() {
    //     window.myDiagram.commandHandler.zoomToFit();
    //   });

    //  document.getElementById('centerRoot').addEventListener('click', function() {
    //    window.myDiagram.scale = 1;
    //    window.myDiagram.commandHandler.scrollToPart(window.myDiagram.findNodeForKey(1000));
    //  });

	// zoomSlider = new ZoomSlider(window.myDiagram, {
	// 	alignment: go.Spot.TopRight, alignmentFocus: go.Spot.TopRight,
	// 	size: 150, orientation: 'vertical'
	// })


    function fetchNodeHeightforBackdrop(e,obj){
        console.log("This is the height::", obj.actualBounds.height)
        
        if (obj.part.data.candidates.length>1){
            return 450
        }
        else{
            return 100
        }
        // obj.actualBounds.height
        // if(obj.part.data.candidates.length)

        
    }

    function nodeClicked(e,obj){

        // console.log("This is the node clicked::", clicked_key_no)
        // console.log("nodeClicked function called")
        console.log("Node clicked::", obj.part.data.key )
        if (sessionStorage['logon'] == 'false'){
            console.log("Showing payment popup when logged out for node::", obj.part.data.key)
            showPaymentPopUpWhenLoggedOut()
        }
        else{
            var user_plan = JSON.parse(localStorage['user'])['plan']['plan']
                if (user_plan == 'plan_0'){
                    console.log("Showing pricing page to user because they are on the free plan")
                    showPricingPagetoUser()
                }
        }
    }


    function getStdFunctions(job_titles_arr) {
        console.log("getStdFunctions FUNCTION CALLED");
        // job_titles_arr = ['sales manager', 'regional enterprise sales head']
        jQuery.ajax({
        url :'/get_std_function_string',
        type : 'POST',
        data : {job_titles : JSON.stringify(job_titles_arr)},
        }).done(function(data) {
            // console.log(data)
            candidate_classification_data = data['std_functions_arr']
            for (var i=0; i < candidate_classification_data.length; i ++){
                console.log(candidate_classification_data[i]['job_title'], "====", candidate_classification_data[i]['std_function'])
            }
        });
    
    }
    
    function sideAssistantNodeClicked(e, obj){
        console.log("sideAssistantNodeClicked clicked")
        var clicked_part_data_assistant = obj.part.data
        console.log(clicked_part_data_assistant)
        var current_std_function_root = clicked_part_data_assistant.std_function_root.replace("assist","")
        console.log( current_std_function_root)
        node_key = obj.part.data.key
        new LoadDataPeopleCompaniesOrgCharts().loadModalfetchAllFunctionDataResults(node_key)
    }

        
    // when a node is double-clicked, send it to go get results for that node
	   function nodeDoubleClick(e, obj) {
           console.log("node Double clicked")
	       var clicked_key_no = obj.part.key;
           console.log("This is key::", clicked_key_no)
        //    console.log("This is key of obj double clicked::", obj.part.key);
        //    node_data_obj = window.myDiagram.findNodeForKey( clicked_key_no).data
        //    candidates_arr = node_data_obj['candidates']
        //    var job_titles_arr = []
        //    for (var i = 0; i < candidates_arr.length; i++){
        //     job_titles_arr.push(candidates_arr[i]['job_title'])
        //    }



        //    context_menu_button_id = obj._buttonID
        //    console.log(context_menu_button_id)
        //    console.log("fetchCurrentNodeDataResults FUNCTION CALLED");
           var node = obj.part;
        //    node_assigned = obj.part;
        //    console.log(node);
        //    console.log(e);
            sessionStorage['fetch_nodes_data_count'] = node.data.len_candidates

            console.log("This could also be key::", node.data.key)
           sessionStorage['selectedNodeKey'] = node.data.key;
        //    node_data = window.myDiagram.findNodeForKey(node.data.key).data
        //    console.log(node_data)
           sessionStorage['selected_context_menu'] = 'fetchCurrentNodeDataResults'
           sessionStorage['data_source'] = 'data_broker_1'
           sessionStorage['consume_credits'] = 'true'
           new Query().fetchQueryShowResults('button_query_show_results')
        //    $(fetch_people_results).modal('hide');
           sessionStorage['consume_credits'] = 'false'
           console.log("fetch all rescults confirmed")
        //    sessionStorage['selected_context_menu'] = ''


        //    console.log("This is candidates_arr job_titles_arr:::",job_titles_arr)
        //    getStdFunctions(job_titles_arr)

	//        if (clicked !== null) {
	//            var thisemp = clicked.data;
	//            window.myDiagram.startTransaction("add employee");
	//            var newemp = {
	//                name: "(new person)",
	//                title: "",
	//                comments: "",
	//                parent: thisemp.key
	//            };
	//            window.myDiagram.model.addNodeData(newemp);
	//            window.myDiagram.commitTransaction("add employee");
	//        }
		}
	
		// this is used to determine feedback during drags
		function mayWorkFor(node1, node2) {
			if (!(node1 instanceof go.Node)) return false; // must be a Node
			if (node1 === node2) return false; // cannot work for yourself
			if (node2.isInTreeOf(node1)) return false; // cannot work for someone who works for you
			return true;
		}
	
		// This function provides a common style for most of the TextBlocks.
		// Some of these values may be overridden in a particular TextBlock.
		function textStyle() {
			return {
				font: "9pt  Segoe UI,sans-serif",
				stroke: "black"
			};
		}
	
		// This converter is used by the Picture.
		// function findHeadShot(key) {
		// 	// if (key < 0 || key > 16) return "images/HSnopic.png"; // There are only 16 images on the server
		// 	//return "images/HS" + key + ".png"
		// 	// return "https://media-exp1.licdn.com/dms/image/C5603AQFLLoi74DGiAw/profile-displayphoto-shrink_200_200/0?e=1592438400&v=beta&t=RQMH-HzKkhwLwtzh_Z7c4Xcpqxcwz8dXCG97Ky9yNpw"
		// 	return "images/HSnopic.png"
		// }
	
		// function findHeadShot1(key) {
		// 	if (key < 0 || key > 16) return "images/HSnopic.png"; // There are only 16 images on the server
		// 	//return "images/HS" + key + ".png"
		// 	return ""
		// }
	
		function findSize(size) {
			return parseInt(size)
		}
	
		function showSeeMore(total_people){
			// Sets height of the node
			// if (parseInt(total_people)>4) {
			// 	return 40
			// } else {
			// 	return 40
			// }
			return 40
		}
	
		function showLabelContainer(label){
			if (label == 'Preview' || label == 'To Contact' || label == 'Met' || label == 'Champion' || label == 'Econ. Buyer') {
				return 20
			} else {
				return 0
			}
		}
	

        function showHeightLabelContainer(candidates){
            if (candidates.length==1){
                return 150
            }
            if (candidates.length==2){
                return 200
            }
            if (candidates.length==3){
                return 250
            }
            if (candidates.length==4){
                return 300
            }
            if (candidates.length>2){
                return 300
            }

        }
		function showLabelContainerTable(label){
			if (label == 'Preview' || label == 'To Contact' || label == 'Met' || label == 'Champion' || label == 'Econ. Buyer') {
				return 40
			} else {
				return 20
			}
		}
	
		function textLabel(label){
			if (label == 'Preview' || label == 'To Contact' || label == 'Met' || label == 'Champion' || label == 'Econ. Buyer') {
				return label
			} else {
				return ''
			}
		}
	
		function colorLabel(label){
			if (label == 'Preview') {
				return 'rgb(102,204,255)'
			} else if (label == 'To Contact') {
				return 'rgb(160,160,160)'
			} else if (label == 'Met') {
				return 'rgb(62,164,255)'
			} else if (label == 'Champion') {
				return 'rgb(0,179,107)'
			} else if (label == 'Econ. Buyer') {
				return 'rgb(230,115,0)'
			} else {
				return ''
			}
		}
	
		function textSeeMore(total_people){
			if (parseInt(total_people)==1) {
				return (parseInt(total_people)).toString() + ' executive'
			} else {
				return (parseInt(total_people)).toString() + ' executives'
			}
		}

		function textSeeMoreCredits(total_people){
			if (parseInt(total_people)==1) {
				return (parseInt(total_people)).toString() + ' credit'
			} else {
				return (parseInt(total_people)).toString() + ' credits'
			}
		}


		function fetchSimilarPeople(e,obj){
            var evt = e.copy();
			var node = obj.part;
            console.log(node.data)
            console.log(node.key)

            var std_function = node.data.std_function;
            var std_grade = node.data.std_grade;
            var function_root = node.data.std_function_root;
            var token_obj = {"std_function": std_function,"std_grade":std_grade, "function_root":function_root };
            updateStorageToken(token_obj, "nodeSimilarPeople")
            // togglePeople()
            // togglePeoplewithData
            new Toggle().togglePeoplewithData(node.data.candidates)


        }

        function fetchProfilesAssistant(e,obj){
            console.log("Calling fetchProfilesAssistant")
            console.log("This ist eh ",obj.part.data.key)
        }


	
        
    
		function loadImage(){
			return "https://st2.depositphotos.com/4111759/12123/v/950/depositphotos_121232442-stock-illustration-male-default-placeholder-avatar-profile.jpg"
		}
	
		// function loadImageNotFound(url){
		// 	return 'https://res.cloudinary.com/arxena/image/upload/v1610166685/yr5sw0zxdymoawt70y3q.jpg'
		// }
	
		function showIfSelectionIsNotMultiple(e) {
			console.log(sessionStorage['selected_nodes'])
			if (JSON.parse(sessionStorage['selected_nodes']).length > 1){
				return false
			} else {
				return true
			}
		}
	
		function showIfSelectionIsMultiple(e) {
			console.log(sessionStorage['selected_nodes'])
			if (JSON.parse(sessionStorage['selected_nodes']).length > 1){
				return true
			} else {
				return false
			}
		}
	
		function findLockLogo(key) {
			// return "https://ya-webdesign.com/images250_/linkedin-icon-png-circle-2.png" //"/static/img/info1_blue.png"
			return "/static/img/lock.png"
		}
        
        function findOrangeIcon(key) {
			// return "https://ya-webdesign.com/images250_/linkedin-icon-png-circle-2.png" //"/static/img/info1_blue.png"
			return "/static/img/orange_dot.png"
		}
        

        function findGreenIcon(key) {
			// return "https://ya-webdesign.com/images250_/linkedin-icon-png-circle-2.png" //"/static/img/info1_blue.png"
			return "/static/img/green_dot.png"
            
		}
        

        function findEyesCartoon(key){
            return "/static/img/eyes-cartoon.png"

        }

        function findPlusIcon(key){
            // return <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABmJLR0QA/wD/AP+gvaeTAAADSUlEQVRoge2aTY9URRSGnzKCiUwMOgGZOBOD8jE/QANL5QcYDBsTomFhxETRjSQu1T3qkuCSxJVbZOmS8WPUJcRRIwnhw7DQ6Uk0Ao+LGqCnw62ubqpudyb32Z5T5573VvXtU1UHOjo6Ojqml1AzuLoLOAQcABaB54BZYGbdpQfcBH4DLgJLwDchhGs18yqKOqu+p37v+HynnlBnJ62nEXVe/Vxdewihg/TUz9RnJq3vHuoW9X11taDQQdbUj9THJi12v/pzRaGD/KTum5TYI9ad1Sb+Vl9tW+wx9b8JiL3LLfXttsQen6DQQU7UFnvE+HanhVvq4VE0ZBce6h5gGXhi1BdVmR7wYgjhYo7zIzlO6lbgK8qIPQfMAwvA+QLxZoAv1S0FYkXUDwsuw/m+uAsF457M0TJ0SRurnEvAtvFfWd8DQ9jwTNUScYlLe18I4WrKKWdJn6SQ2MrMAB8Mc0rOsLF4vww8XiipmjMMsAY8G0K42eQwbIaPUlBsC2wDXks5DBP8erlcWuONlLFxSatzwJWUzzhUXtIAAnMhhOsPMqZm+GUqn4hUIgAvNRlTgg+Uz6U1DjYZUoIXKyTSFvubDCnBeyok0hZ7mwwpwdszg58D5kMmg4NHGDdK7f1kpt991H9HrY1rM0Lt/U9TjKzd0mYiJbiXGeNMG7OsLgBnMt1XmwypwmMFeH7EvIbSQuEBsBJCeOCHKzXDv1ZIpC1+aTKkBGcdmUwpl5oMKcFLFRJpiwtNhtRv+GngaspnHKZ287A+4IfCybTBt01iYfj/8NnCybRBMuecI54/KHimNdVHPOsDvyiYUG1Op8TC5jqmXSUe0ybbJYbW0iGEK8AnhZLCgYP4UnGBj4v1hhhv+X/M3KkM42tje8SCer5QzGUzr1o2y2XaCyGExuqqn+ztYQhhBTgG3B4zsRrcBo7mih0L9a1Cy/BhuaO+WU3ogOhpaHk43orYPtGHjQ0mbfOX+kqrYvtE77Xc1zuHZePHc3Kojxob02rO9t3GtK0TFduPOqd+amwXLEVPPWVsUp1OjM2l76pLxi/pqNxRL6jvqE+Vzq92+/BO4qXcQeLVzW5gBxvbh/8Efmdj+/CNmnl1dHR0dEwr/wPjXf6j9efZGgAAAABJRU5ErkJggg=="></img>
            // return 'static/img/icons8-plus-40.png'
            return ''
        }
	
		function findLinkedinLogo(key) {
			return "/static/img/linkedin-icon-png-circle-2.png" //"/static/img/info1_blue.png"
		}

        function findDownloadIcon(key){
            return "/static/img/download-icon.png"
        }


        function findSimilarItemsIcon(key){
            return "/static/img/similar-items.png"
        }



        function findEyesCartoon(key){
            return "/static/img/similar-items.png"
        }

return window.myDiagram
}

// Search, context menu, modals, export, blocks, node mutation are in modules (see imports).

function fetchNodeContextMenuClickedResults(e, obj){

    console.log("Clicked fetchNodeContextMenuClickedResults")
    var user_plan_obj = localStorage['user']
    if (user_plan_obj != '{}'){
        var user_plan = JSON.parse(user_plan_obj)['plan']['plan']
    }
    else{
        var user_plan = undefined
    }

    if (obj === undefined){
        console.log ("This is E::", e);
        var context_menu_button_id = e
    }
    else{
        var context_menu_button_id = obj._buttonID   
    }

    if (sessionStorage['logon'] == 'false'){
        showPaymentPopUpWhenLoggedOut()
    }
    else{
        var user_plan = JSON.parse(localStorage['user'])['plan']['plan']
        if (user_plan == 'plan_0'  || user_plan === undefined){
            showPricingPagetoUser()
        }

        else{
            var credits_to_be_used = compute_credits()
            console.log("context_menu_button_id is :::::", context_menu_button_id)
            // console.log(document.getElementById('required_credits').innerHTML);
            console.log(credits_to_be_used);
            console.log("context_menu_button_id that got clicked:::", context_menu_button_id)
            // change query from fetchEntireCompanyDataResults to fetchAllFunctionDataResults
            if (JSON.parse(sessionStorage['query'])['function_root'].length>0){
                context_menu_button_id == 'fetchAllFunctionDataResults'   
            }
            if( ( context_menu_button_id == 'fetchCurrentNodeDataResults' ) || (context_menu_button_id == 'textSeeMoreCredits') || (context_menu_button_id == 'findLockLogo')){
                context_menu_button_id = obj._buttonID
                console.log(context_menu_button_id)
                console.log("fetchCurrentNodeDataResults FUNCTION CALLED");
                var node = obj.part;
                var node_assigned = obj.part;
                console.log(node);
                console.log(e);
                sessionStorage['selectedNodeKey'] = node.data.key;
                var node_data = window.myDiagram.findNodeForKey(node.data.key).data
                console.log("This is th node data::", node_data)
                sessionStorage['selected_context_menu'] = 'fetchCurrentNodeDataResults'
                sessionStorage['data_source'] = 'data_broker_3'
                // document.getElementById("select_positions_dropdown").innerHTML = 'Select positions'
                $(fetch_node_results).modal('show');
                try{
                    document.getElementById("dataCoverageRadio3_org_charts").checked = true;
                    document.getElementById("dataSourceRadio3_org_charts").checked = true;
                }
                catch{}
                
                document.getElementById("headline_modal_fetch_people").innerHTML = '<h5><strong>Fetch '+node_data['std_function']+  " teams at "+node_data['std_grade']  +' level</strong></h5>'
                new Query().fetchQueryShowResults('locations_dropdown1')
                new Query().fetchQueryShowResults('cost_credits')
                console.log("Setting fetch nodes data count")
                
        
            }
        
            else if (( context_menu_button_id == 'fetchEntireCompanyDataResults' )||( context_menu_button_id == 'fetchCanvasEntireCompanyDataResults' )){
                console.log("fetchEntireCompanyDataResults FUNCTION CALLED");
                // disabling reset
                // new Tokens().resetFunctionsGradesDropdown()
                // fetchEntireCompanyDataResults 
                
                
                // node = obj
                // node_assigned = obj.part;
                // console.log(node);
                // Desselcteing for now
                sessionStorage['selectedNodeKey'] = obj;
       
                sessionStorage['selected_context_menu'] = 'fetchEntireCompanyDataResults'
                if (JSON.parse(sessionStorage['query'])['function_root'].length>0){
                    sessionStorage['selected_context_menu'] = 'fetchAllFunctionDataResults'
                }
                sessionStorage['data_source'] = 'data_broker_3'
                // document.getElementById("select_positions_dropdown").innerHTML = 'Select positions'
                $(fetch_node_results).modal('show');

                try{
                    document.getElementById("dataCoverageRadio3_org_charts").checked = true;
                    document.getElementById("dataSourceRadio3_org_charts").checked = true;
                }
                catch{}
                document.getElementById("headline_modal_fetch_people").innerHTML = '<h5><strong>Fetch Entire Company Data</strong></h5>'
                new Query().fetchQueryShowResults('locations_dropdown1')
                new Query().fetchQueryShowResults('cost_credits')
                // element = document.getElementById('fetch_nodes_data_count')
                // element.setAttribute("value", sessionStorage['count_db_results']);

            }

            else if (context_menu_button_id == 'boolean_keywords_string'){
                sessionStorage['boolean_keywords_string'] = 'true'
                var node = obj.part;
                sessionStorage['selectedNodeKey'] = node.data.key;
                sessionStorage['selected_context_menu'] = 'fetchCurrentNodeDataResults'
                new Query().fetchQueryShowResults('boolean_keywords_string')
            }
            else if ( context_menu_button_id == 'fetchAllLeadershipNodes' ){
                console.log("fetchAllLeadershipNodes FUNCTION CALLED");
                try{
                    var node = obj.part;
                    var node_assigned = obj.part;
                    console.log(node);
                    sessionStorage['selectedNodeKey'] = node.data.key;
                }
                catch{}
                sessionStorage['selected_context_menu'] = 'fetchAllLeadershipNodes'
                sessionStorage['data_source'] = 'data_broker_3'
                // document.getElementById("select_positions_dropdown").innerHTML = 'Select positions'
                $(fetch_node_results).modal('show');
                try{
                    document.getElementById("dataCoverageRadio3_org_charts").checked = true;
                    document.getElementById("dataSourceRadio3_org_charts").checked = true;
                }
                catch{}
                document.getElementById("headline_modal_fetch_people").innerHTML = '<h5><strong>Fetch all leadership nodes</strong></h5>'
                new Query().fetchQueryShowResults('locations_dropdown1')
                new Query().fetchQueryShowResults('cost_credits')
                // element = document.getElementById('fetch_nodes_data_count')
                // element.setAttribute("value", sessionStorage['count_db_results']);
            }
            else if ( context_menu_button_id == 'fetchAllSelectedNodes' ){
                console.log("fetchAllSelectedNodes FUNCTION CALLED");
                var node = obj.part;
                var node_assigned = obj.part;
                console.log(node);
                sessionStorage['selectedNodeKey'] = node.data.key;
                sessionStorage['selected_context_menu'] = 'fetchAllSelectedNodes'
                sessionStorage['data_source'] = 'data_broker_3'
                // document.getElementById("select_positions_dropdown").innerHTML = 'Select positions'
                $(fetch_node_results).modal('show');
                try{
                    document.getElementById("dataCoverageRadio3_org_charts").checked = true;
                    document.getElementById("dataSourceRadio3_org_charts").checked = true;
                }
                catch{}
                document.getElementById("headline_modal_fetch_people").innerHTML = '<h5><strong>Fetch all selected nodes</strong></h5>'
                new Query().fetchQueryShowResults('locations_dropdown1')
                new Query().fetchQueryShowResults('cost_credits')
                var element = document.getElementById('fetch_nodes_data_count')
                element.setAttribute("value", sessionStorage['count_db_results']);
            }
            else if ( context_menu_button_id == 'fetchAllFunctionDataResults' ){
                console.log("fetchAllFunctionDataResults FUNCTION CALLED");
                var node = obj.part;
                var node_assigned = obj.part;
                console.log(node);
                sessionStorage['selectedNodeKey'] = node.data.key;
                sessionStorage['selected_context_menu'] = 'fetchAllFunctionDataResults'
                sessionStorage['data_source'] = 'data_broker_3'
                // document.getElementById("select_positions_dropdown").innerHTML = 'Select positions'
                $(fetch_node_results).modal('show');
                try{
                    document.getElementById("dataCoverageRadio3_org_charts").checked = true;
                    document.getElementById("dataSourceRadio3_org_charts").checked = true;
                }
                catch{}
                document.getElementById("headline_modal_fetch_people").innerHTML = '<h5><strong>Fetch all names in the '+node.data.std_function_category.replace("assist","")+' function</strong></h5>'
                // if (node.data.std_function_category.replace("assist","") =='ceo'){
                // }
                new Query().fetchQueryShowResults('locations_dropdown1')
                new Query().fetchQueryShowResults('cost_credits')
                var element = document.getElementById('fetch_nodes_data_count')
                element.setAttribute("value", sessionStorage['count_db_results']);
            }
            else if ( context_menu_button_id == 'fetchOrgChartFunctionGradeDataResults' ){
                console.log("fetchOrgChartFunctionGradeDataResults FUNCTION CALLED");
                // node = obj.part;
                // node_assigned = obj.part;
                // console.log(node);
                // sessionStorage['selectedNodeKey'] = node.data.key;
                // Setting selected context menu to fetchOrgChartFunctionGradeDataResults because the backend will process node data only accordingly
                sessionStorage['selected_context_menu'] = 'fetchOrgChartFunctionGradeDataResults'
                sessionStorage['data_source'] = 'data_broker_3'
                // document.getElementById("select_positions_dropdown").innerHTML = 'Select positions'
                $(fetch_node_results).modal('show');
                try{
                    document.getElementById("dataCoverageRadio3_org_charts").checked = true;
                    document.getElementById("dataSourceRadio3_org_charts").checked = true;
                }
                catch{}
                var org_chart_data_company_name = sessionStorage['org_chart_data_company_name']

                document.getElementById("headline_modal_fetch_people").innerHTML = '<h5><strong>Fetch names from '+org_chart_data_company_name+' </strong></h5>'
                new LoadDataPeopleCompaniesOrgCharts().loadFunctionsTreeDropdown()
                new LoadDataPeopleCompaniesOrgCharts().loadGradesDropdown()
                new Query().fetchQueryShowResults('locations_dropdown1')
                // new Query().fetchQueryShowResults('cost_credits')
                new Tokens().resetFunctionsGradesDropdown()
                var element = document.getElementById('fetch_nodes_data_count')
                element.setAttribute("value", sessionStorage['count_db_results']);
            }

            else if ( context_menu_button_id == 'fetchNodeFunctionGradeDataResults' ){
                console.log("fetchNodeFunctionGradeDataResults FUNCTION CALLED");
                var node = obj.part;
                var node_assigned = obj.part;
                console.log(node);
                new Tokens().resetFunctionsGradesDropdown()

                sessionStorage['selectedNodeKey'] = node?.data?.key;
                // Setting selected context menu to fetchCurrentNodeDataResults because the backend will process node data only accordingly
                sessionStorage['selected_context_menu'] = 'fetchNodeFunctionGradeDataResults'
                sessionStorage['data_source'] = 'data_broker_1'
                // document.getElementById("select_positions_dropdown").innerHTML = 'Select positions'
                $(fetch_node_results).modal('show');

                try{
                    document.getElementById("dataCoverageRadio1_org_charts").checked = true;
                    document.getElementById("dataSourceRadio1_org_charts").checked = true;
                }
                catch{}
                
                document.getElementById("headline_modal_fetch_people").innerHTML = '<h5><strong>Fetch all names in the '+node?.data?.std_function_category.replace("assist","")+' function</strong></h5>'
                new LoadDataPeopleCompaniesOrgCharts().loadFunctionsTreeDropdown()
                new LoadDataPeopleCompaniesOrgCharts().loadGradesDropdown()
                new Query().fetchQueryShowResults('locations_dropdown1')
                // new Query().fetchQueryShowResults('cost_credits')
                var element = document.getElementById('fetch_nodes_data_count')
                element.setAttribute("value", sessionStorage['count_db_results']);
            }
            else if ( context_menu_button_id == 'fetchCurrentPositionAcrossCompaniesResults' ){
                console.log("fetchCurrentPositionAcrossCompaniesResults function called!")
        
                var node = obj.part;
                var std_function = node?.data?.std_function
                var std_grade = node?.data?.std_grade
                var token_obj = {"std_function":std_function, "std_grade":std_grade}
                console.log("This is the final token object infetchCurrentPositionAcrossCompaniesResults ", token_obj)
                updateStorageToken(token_obj,"contextMenu_fetchCurrentPositionAcrossCompaniesResults")
                togglePeople()
                // new Query().fetchQueryShowResults()
                // new Query().fetchQueryShowResults('cost_credits')
            }
            else if (context_menu_button_id == 'viewThisPositioninPeopleTab'){
                var node = obj.part;
                var std_function = node?.data?.std_function
                var std_grade = node?.data?.std_grade
                var token_obj = {
                    "std_function":std_function, "std_grade":std_grade
                }
                updateStorageToken(token_obj,"contextMenu")
                togglePeople()
                // new Query().fetchQueryShowResults()
            }
            else if (context_menu_button_id =='viewCanvasNodeDataInPeopleTab'){
                togglePeople()
            }
            else if (context_menu_button_id == 'viewCanvasNodeDataInCompaniesTab'){
                toggleCompanies()
            }
        }
    }
}

// processCandidate, processMultipleNodes, etc. are in diagram-node-mutation.js (see imports).

// Export and attach to window for HTML onclick handlers and paramsStorageobj
export {
  loadOrgChartDiagram,
  clearSelectedBlocksList,
  addToSelectedBlocksList,
  addToDeletedBlocksList,
  searchDiagram,
  centerToNextResult,
  centerToPreviousResult,
  clearSearch,
  processMultipleNodes,
  processCandidate,
  fetchNodeContextMenuClickedResults,
  SideTreeLayout,
};
if (typeof window !== 'undefined') {
  window.loadOrgChartDiagram = loadOrgChartDiagram;
  window.clearSelectedBlocksList = clearSelectedBlocksList;
  window.addToSelectedBlocksList = addToSelectedBlocksList;
  window.addToDeletedBlocksList = addToDeletedBlocksList;
  window.searchDiagram = searchDiagram;
  window.centerToNextResult = centerToNextResult;
  window.centerToPreviousResult = centerToPreviousResult;
  window.clearSearch = clearSearch;
  window.processMultipleNodes = processMultipleNodes;
  window.processCandidate = processCandidate;
  window.fetchNodeContextMenuClickedResults = fetchNodeContextMenuClickedResults;
  window.SideTreeLayout = SideTreeLayout;
}
